import { head, last, tail } from 'lodash';

const modal = {
  namespaced: true,
  state: {
    isVisible: false,
    modalData: {},
    modalDatas: [],
  },
  getters: {},
  mutations: {
    ENQUEUE(state, modalData) {
      Object.assign(state, {
        isVisible: true,
        modalData: head(state.modalDatas) || modalData,
        modalDatas: [...state.modalDatas, modalData],
      });
    },
    DEQUEUE(state) {
      if (!state.modalDatas.length) return;

      Object.assign(state, {
        isVisible: state.modalDatas.length !== 1,
        modalData: state.modalDatas.length === 1 ? {} : last(state.modalDatas),
        modalDatas: tail(state.modalDatas),
      });
    },
  },
  actions: {
    show({ commit }, modalData) {
      return commit('ENQUEUE', modalData);
    },
    close({ commit, state: { modalData: { callback } } }) {
      if (callback) {
        callback();
      }
      return commit('DEQUEUE');
    },
    isModalOnQueueOrActive({ state: { modalDatas } }, search) {
      return modalDatas.some(({ content }) => content === search);
    },
  },
};

export default modal;
